import styled from 'styled-components'
import rtl from 'styled-components-rtl'
import { Link } from 'gatsby'
import { navLinkStyle } from '@berlitz/nav-widget'

export const StyledNavLink = styled(Link)`
  ${navLinkStyle};
  width: 100%;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    width: auto;
    ${rtl`
      margin-left: 0;
    `}
  }
`
